import React from "react"
import { Link } from "gatsby"
import { format } from "date-fns"
import Edit from "../../../../images/edit.svg"
import Loader from "../../../Loader"

const Summary = (props) => {
  let {
    shareholder_type,
    firstname,
    lastname,
    nationality,
    occupation,
    gender,
    identity_type,
    identity_number,
    identity,
    shareholder_signature,
    shareholder_address,
    shareholder_country,
    shareholder_state,
    shareholder_city,
    shareholder_email,
    shareholder_phone,
    no_of_shares,
    is_shareholder_director,
  } = props.data

  return (
    <div className="container summary">
      <div className="form-row">
        <div className="col-lg-8">
          <div className="my-lg-5 waitlist__form">
            <div className="form-row">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">Shareholder Type</p>
                <p className="summary-description">{shareholder_type}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">First Name</p>
                <p className="summary-description">{firstname}</p>
              </div>

              <div className="form-group col-lg-5 offset-lg-1 my-3">
                <p className="mb-1 summary-title">Last Name</p>
                <p className="summary-description">{lastname}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">Phone Number</p>
                <p className="summary-description">{shareholder_phone}</p>
              </div>

              <div className="form-group col-lg-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Email Address</p>
                <p className="summary-description">{shareholder_email}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">Gender</p>
                <p className="summary-description">{gender}</p>
              </div>

              <div className="col-lg-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Occupation</p>
                <p className="summary-description">{occupation}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">Country</p>
                <p className="summary-description">{shareholder_country}</p>
              </div>

              <div className="col-lg-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Country</p>
                <p className="summary-description">{shareholder_country}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">State</p>
                <p className="summary-description">{shareholder_state}</p>
              </div>

              <div className="form-group col-lg-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">City</p>
                <p className="summary-description">{shareholder_city}</p>
              </div>
            </div>

            <div className="form-row">
              <div className="col-lg-12 my-3">
                <p className="mb-1 summary-title">Business Address</p>
                <p className="summary-description">{shareholder_address}</p>
              </div>
            </div>

            <div className="form-row">
              <div className="col-lg-5 my-3">
                <p className="mb-1 summary-title">Share Capital</p>
                <p className="summary-description">{no_of_shares}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Summary
